import { render, staticRenderFns } from "./section-oxygen-minus-event-table.vue?vue&type=template&id=1b11ae94&scoped=true"
import script from "./section-oxygen-minus-event-table.vue?vue&type=script&lang=js"
export * from "./section-oxygen-minus-event-table.vue?vue&type=script&lang=js"
import style0 from "./section-oxygen-minus-event-table.vue?vue&type=style&index=0&id=1b11ae94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b11ae94",
  null
  
)

export default component.exports